import Tag from 'src/models/Tag';
 
const tagsToString = (tagItems: Tag[]) => {
    let tempString = '';
    tagItems.forEach((tag, index) => {
        tempString = tempString.concat(tag.name);
        if (tag !== tagItems[tagItems.length - 1]) {
            tempString = tempString.concat(', ');
        }
    });
    return (
        tempString.concat(' ')
    );
};

export default tagsToString;


// WEBPACK FOOTER //
// ./src/components/common/UtilityFunctions.tsx